import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/hooks';
import { authService } from '@/api';
import { ROUTE_DEFINITIONS } from '@/routes';
import { PageSpinner } from '@/components/ui/loading';


interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const {
    token, tokenExpiry, isAuthenticated, isInitializing,
  } = useAppSelector((state) => state.auth);

  // Mientras se verifica si hay sesión SSO pendiente, mostrar spinner
  if (isInitializing) {
    return <PageSpinner />;
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated || !token || !tokenExpiry) {
    return <Navigate to={ROUTE_DEFINITIONS.INICIAR_SESION.path} replace />;
  }

  // Si el token está expirado, redirigir al login
  const expiry = new Date(tokenExpiry);
  if (authService.isTokenExpired(expiry)) {
    return <Navigate to={ROUTE_DEFINITIONS.INICIAR_SESION.path} replace />;
  }

  // Token válido, renderizar el contenido protegido
  return <>{children}</>;
};
